
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import LatAmFlags from './components/LatAmFlags';
import Services from './components/Services';
import Industries from './components/Industries';
import About from './components/About';
import CaseStudies from './components/CaseStudies';
import Contact from './components/Contact';
import CTA from './components/CTA';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation scrolled={scrolled} />
      <Hero />
      <LatAmFlags />
      <Services />
      <Industries />
      <About />
      <CaseStudies />
      <Contact />
      <CTA />
      <Footer />
    </div>
  );
}
